import { render, staticRenderFns } from "./arbitrageShow.vue?vue&type=template&id=524672ac&scoped=true"
import script from "./arbitrageShow.vue?vue&type=script&lang=js"
export * from "./arbitrageShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524672ac",
  null
  
)

export default component.exports